import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { PaginatedResponse, Response as ApiResponse } from '@/types/api/response.types';
import {
  CreditRequest,
  CreditRequestCount,
  CreditRequestPaginationParams,
  CreditRequestParams,
  CreditRequestSite,
  CreditRequestSiteParams,
  CreditRequestTableItem,
} from '@/types/api/credit-requests.type';
import { ReturnCreatedBy, ReturnStatusUpdateBody } from '@/types/api/returns.types';
import { DocumentUploadResponse } from '@/types/api/orders.types';

const resource = '/credit-requests';

export const updateCreditRequestStatus = async (
  id: string,
  data: ReturnStatusUpdateBody,
): Promise<AxiosResponse<ApiResponse<CreditRequest>>> => {
  return axiosRequest().patch(`${resource}/${id}/status`, data);
};

export const getAllCreditRequests = async (
  params: CreditRequestPaginationParams,
): Promise<AxiosResponse<PaginatedResponse<CreditRequestTableItem[]>>> => {
  return axiosRequest().get(`${resource}`, { params });
};

export const getCreditRequestCount = async (
  params: CreditRequestParams,
): Promise<AxiosResponse<ApiResponse<CreditRequestCount>>> => {
  return axiosRequest().get(`${resource}/counts`, { params });
};

export const getCreditRequestSites = async (
  params: CreditRequestSiteParams,
): Promise<AxiosResponse<ApiResponse<CreditRequestSite[]>>> => {
  return axiosRequest().get(`${resource}/sites`, { params });
};

export const getCreditRequestStatuses = async (): Promise<AxiosResponse<ApiResponse<string[]>>> => {
  return axiosRequest().get(`${resource}/statuses`);
};

export const getCreditRequestCreatedBy = async (
  params: CreditRequestSiteParams,
): Promise<AxiosResponse<ApiResponse<ReturnCreatedBy[]>>> => {
  return axiosRequest().get(`${resource}/created-by`, { params });
};

export const getCreditRequestDetails = async (
  id: string,
): Promise<AxiosResponse<ApiResponse<CreditRequest>>> => {
  return axiosRequest().get(`${resource}/${id}`);
};

export const getCreditRequestDoc = async (
  id: string,
  documentId: string,
): Promise<AxiosResponse<ApiResponse<DocumentUploadResponse>>> => {
  return axiosRequest().get(`${resource}/${id}/documents/${documentId}`);
};

export const uploadProofOfCredit = async (
  id: string,
  data: FormData,
): Promise<AxiosResponse<ApiResponse<DocumentUploadResponse>>> => {
  return axiosRequest().post(`${resource}/${id}/documents`, data);
};
